<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Dettaglio tipo abbonamento #' + this.$route.params.id : 'Nuovo tipo abbonamento')">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio || this.$route.params.id == null)">
                        <b-row class="my-1">
                            <b-col sm="3"><label for="descrizione">Descrizione:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="tipoabb.descrizione" id="descrizione" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="ggval">Giorni di validità:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="tipoabb.ggval" id="ggval" type="number"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="datainizio">Data inizio:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="tipoabb.datainizio" id="datainizio" type="date"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="datafine">Data fine:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="tipoabb.datafine" id="datafine" type="date"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row  class="my-1">
                            <b-col sm="3"><label for="importo">Importo:</label></b-col>
                            <b-col sm="9">
                                <b-input-group prepend="€">
                                    <b-form-input v-model="tipoabb.importo" id="importo" type="number"></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flgatt">Attivo:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="tipoabb.flagatt" :options="options_attivo" id="flagatt">

                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flgsocio">Profilo soci:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="tipoabb.flgsocio" :options="options_profilotipoabb" id="flgsocio">
                                    
                                </b-form-select>
                            </b-col>
                        </b-row>
                            
                        <b-row class="my-1" v-if="tipoabb.id != null">
                            <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="tipoabb.datains" id="datains" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>                                
                        <b-row class="my-1" v-if="tipoabb.id != null">
                            <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="tipoabb.uteins" id="uteins" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>    
                        <b-row class="my-3">
                            <b-col sm="6" offset-sm="3">
                                <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                    <div v-if="tipoabb.id != null">
                                        Salva
                                    </div>
                                    <div v-else>
                                        Inserisci
                                    </div>
                                </b-button>
                            </b-col>                                                                
                        </b-row>
                        <b-row class="my-3">      
                            <b-col sm="6" offset-sm="3" v-show="tipoabb.id != null">  
                                <b-button block size="md" :disabled="tipoabb.flagatt != 'N'" variant="outline-secondary" v-on:click="disattiva()">
                                    Disattiva abbonamenti soci
                                </b-button>
                            </b-col>
                        </b-row>    
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    Socio
} from '../classes.js'

import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'appdettaglio',
    data: function () {
        return {
            
            namespace: NAMESPACE,
            tipoabb: {
                id: this.$route.params.id || null,
                descrizione: '',
                datainizio: '',
                datafine: '',
                ggval: '',
                importo: '0',
                flagatt: 'S',
                flgsocio: 'T',
                datains: null,
                uteins: ''
            },                    
            error: '',
            options_profilotipoabb: [],
            options_attivo: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],   
            showerror: false,
            showdettaglio: false,
            dismissSecs: 2,
            dismissCountDown: 0,                 
        };
    },
    methods: {                
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        disattiva() {

            let res = confirm("Confermi di voler disattivare questa tipologia di abbonamento per tutti i soci?");
            if(res){
                var token = localStorage.getItem('token');
                this.axios.get(NAMESPACE + 'rest/disattivaabbonamenti/id_tipoabb/' + this.tipoabb.id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {
                                
                                if (response.data.token != null) localStorage.setItem('token', response.data.token);
                                alert("Sono stati disattivati " + response.data.message + " abbonamenti.");

                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {

                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {

                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
            }
        },
        insert() {
            var appdettaglio = this;

            if (this.tipoabb.descrizione == "") {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo descrizione vuoto!";               
            } else if (this.tipoabb.ggval == "") {
                appdettaglio.showerror = true;
                appdettaglio.error = "Indicare i giorni di validità!";     
            } else if (this.tipoabb.datainizio == "" || this.tipoabb.datainizio == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo data inizio vuoto!";

            } else if (this.tipoabb.datafine == "" || this.tipoabb.datafine == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo data fine vuoto!";

            } else if (this.tipoabb.datafine < this.tipoabb.datainizio) { //sono stringhe yyyy-mm-dd
                appdettaglio.showerror = true;
                appdettaglio.error = "Data inizio maggiore di data fine!";      
            } else {
                
                var json = JSON.stringify(this.tipoabb);                

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/tipoabbonamento', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.tipoabb = res[0];
                                    this.showerror = false;
                                    this.showdettaglio = true; //anche se non dovrebbe servire                                 
                                    this.dismissCountDown = this.dismissSecs;

                                    this.$router.replace('/app/dettagliotipoabbonamento/' + this.tipoabb.id);

                                    setTimeout(function() {
                                        //window.history.back();
                                        appdettaglio.$router.go(-1);
                                    }, 2500);

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }

                            } else {
                                throw new Error(response.data.message);
                            }

                        } catch (e) {
                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
            }

        }
    },
    created: function () {
        
        if(!ctrlVismenu("A")){
            this.$router.replace('/accessdenied');
            return;
        }

        var id = this.tipoabb.id; //se è la prima volta si prova a prendere da getid 

        if (id != null) {

            var token = localStorage.getItem('token');
            var appdettaglio = this;

            this.axios.get(NAMESPACE + 'rest/tipoabbonamento/' + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {
                                appdettaglio.tipoabb = res[0];
                                appdettaglio.showdettaglio = true;


                            } else {
                                throw new Error("Errore dati non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        }

        //creo la tendina
         var sc = new Socio();
        var tipi = sc.getListaProfiliTipoAbbonamento();
        var keys = Object.keys(tipi);
        var options_vis = [];
        for (var i = 0; i < keys.length; i++) {
            options_vis.push({
                value: keys[i],
                text: tipi[keys[i]]
            });
        }
        this.options_profilotipoabb = options_vis;

    },
    mounted: function() { 
        
    }

}
</script>
